__turbopack_context__.v({
  "className": "plusjakarta_acde78c-module__wYJCMa__className",
  "variable": "plusjakarta_acde78c-module__wYJCMa__variable",
});
